import React, {memo} from "react"
import {Form} from "antd"
import {CustomInput} from "../../../components/Custom/Input"
import {useTranslation} from "react-i18next";

const FIOInput = memo((props: any) => {
    const { form, isNotToChange } = props
    const user = props.user ? props.user : {}
    const {t} = useTranslation(['resources', 'translation'])
    return (
        <>
            <Form.Item
                initialValue={user.fam}
                label={t('ApplicationUserFam')}
                name="fam"
                className="new-block"
                rules={[
                    {
                        required : true,
                        message : t('validation:RequiredField')
                    },
                    {
                        min: 3,
                        max : 40,
                        message : t('validation:LengthErr')
                    }
                ]}
            >
                <CustomInput
                    allowClear
                    autoComplete="off"
                    disabled={isNotToChange}
                    maxLength={100}
                    placeholder={t('ApplicationUserFam')}
                />
            </Form.Item>
            <Form.Item
                initialValue={user.name}
                label={t('ApplicationUserFirstName')}
                name="name"
                rules={[
                    {
                        required : true,
                        message : t('validation:RequiredField')
                    },
                    {
                        min: 2,
                        max : 40,
                        message : t('validation:LengthErr')
                    }
                ]}
            >
                <CustomInput
                    allowClear
                    autoComplete="off"
                    disabled={isNotToChange}
                    maxLength={100}
                    placeholder={t('ApplicationUserFirstName')}
                />
            </Form.Item>
            <Form.Item
                initialValue={user.otc}
                label={t('ApplicationUserOtc')}
                name="otc"
                rules={[
                    {
                        max : 40,
                        message : t('validation:MaxLengthErr')
                    }
                ]}
            >
                <CustomInput
                    allowClear
                    autoComplete="off"
                    disabled={isNotToChange}
                    maxLength={100}
                    placeholder={t('ApplicationUserOtc')}
                />
            </Form.Item>
        </>
    )
})

export default FIOInput
